import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getObjectKeys } from '@pkg/types';

import config from '@app/config';
import { type FeatureFlags, type FeatureFlagState, type SetFeaturesAction } from '@app/store/types/features';

import { toggleAllFeatueFlags } from './utils';

const name = 'features';

const { featureFlags } = config;
export const defaultFeatures: FeatureFlags = featureFlags;

getObjectKeys(featureFlags).map((key) => {
    defaultFeatures[key] = Boolean(featureFlags[key]);
});

const initialState: FeatureFlagState = {
    features: defaultFeatures,
};

export const featuresSlice = createSlice({
    name,
    initialState,
    reducers: {
        resetFeaturesStore() {
            return initialState;
        },
        setFeatures(state, { payload }: SetFeaturesAction) {
            const showAdminInfo = Boolean(localStorage.getItem('ff-showAdminInfo'));
            const features = { ...state.features, ...payload };
            state.features = { ...features, showAdminInfo: showAdminInfo };
        },
        setFeaturesAll(state, action: PayloadAction<boolean>) {
            state.features = toggleAllFeatueFlags({ ...state.features }, action.payload);
        },
    },
});
